import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import component from './add-vehicle.component'

let module = angular.module('addVehiclePageModule', [
  uiRouter
])

.config(($stateProvider) => {
  'ngInject'

  $stateProvider
    .state('profile.myGarageAdd', {
      url: '/my-garage/add',
      component: 'addVehiclePage',
      authenticate: true
    })
})

.component('addVehiclePage', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/profile/my-garage/add-vehicle/index.js